/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');



window.Vue = require('vue');
window.Event = new Vue();

window.Fire = new Vue();

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)


import Gate from './Gate'
Vue.prototype.$gate = new Gate(window.user)
    // Vue.prototype.$id = new Gate(window.id)

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
//import 'vue-search-select/dist/VueSearchSelect.css'


const datepickerOptions = {}

Vue.use(AirbnbStyleDatepicker, datepickerOptions)


// Vue.component('example-component', require('./components/ExampleComponent.vue'));
// Vue.component('products', require('./components/Sale-Product.vue'));


//POS
Vue.component('products', require('./POS/Product.vue'));
Vue.component('Services', require('./POS/Service.vue'));
Vue.component('Location', require('./POS/Location.vue'));
Vue.component('Trial', require('./POS/Trial.vue'));
Vue.component('Other', require('./POS/OtherService.vue'));
Vue.component('Receipt', require('./Report/reprint.vue'));
//Item
Vue.component('item-services', require('./Item/Services.vue'));
Vue.component('item-locations', require('./Item/Location.vue'));
Vue.component('item-products', require('./Item/Products.vue'));
Vue.component('item-trials', require('./Item/Trials.vue'));
Vue.component('item-others', require('./Item/Others.vue'));
// Reports
Vue.component('endofday', require('./Report/EndDay/endOfDay.vue'));
Vue.component('transaction-end-of-day', require('./Report/EndDay/transaction.vue'));
Vue.component('product-end-of-day', require('./Report/EndDay/product.vue'));
Vue.component('payment-end-of-day', require('./Report/EndDay/payment.vue'));

Vue.component('product-report', require('./Report/Report/Product.vue'));
Vue.component('service-report', require('./Report/Report/Service.vue'));
Vue.component('payment-report', require('./Report/Report/Payment.vue'));
Vue.component('location-report', require('./Report/Report/Location.vue'));
Vue.component('service-maria-report', require('./Report/Report/ServiceMaria.vue'));

//Others
Vue.component('notfound', require('./NotFound/NotFound.vue'));
Vue.component('settings', require('./Others/Settings/settings.vue'));
Vue.component('users', require('./Others/Admin/Users.vue'));

//Emaar
Vue.component('daily-sales', require('./Emaar/DailySales.vue'));
Vue.component('posted-daily-sales', require('./Emaar/PostedDailySales.vue'));
Vue.component('monthly-sales', require('./Emaar/MonthlySales.vue'));
Vue.component('posted-monthly-sales', require('./Emaar/PostedMonthlySales.vue'));

const app = new Vue({
    el: '#app',
    data: { myDate: new Date().toISOString().slice(0, 10), id: window.user.id, staffname: window.user.first_name }
});


// WEBPACK FOOTER //
// ./resources/js/app.js